import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/paramSettings'

export const paramSettingsService = {
    search,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    hardDelete,
    syncFirebase
};

function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data, showAlert: false })
}

function syncFirebase() {
    return utilHelper.doRequest(`${relativeUrl}/syncFirebase`, 'GET')
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/getItem/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data});
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data});
}

function deleteItem(id, db) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${db}`, 'DELETE', { })
}

function hardDelete(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/hardDelete/${id}`, 'DELETE', { })
}